import { createPaginator } from "@smithy/core";
import { GetContentModerationCommand, } from "../commands/GetContentModerationCommand";
import { RekognitionClient } from "../RekognitionClient";
export const paginateGetContentModeration = createPaginator(RekognitionClient, GetContentModerationCommand, "NextToken", "NextToken", "MaxResults");
